"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  number: "01",
  name: "Viral Growth Engine",
  location: "AMSTERDAM, NETHERLANDS",
  year: "2024",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/social_media_strategy_dashboard.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/social_media_strategy_dashboard.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/social_media_strategy_dashboard.webp-wvc-sizes",
  alt: "Social media strategy dashboard showing exponential growth metrics",
  aspect: "aspect-[4/5]",
  layout: "left"
}, {
  number: "02",
  name: "Brand Authority Hub",
  location: "ROTTERDAM, NETHERLANDS",
  year: "2024",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/content_creation_studio_setup.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/content_creation_studio_setup.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/content_creation_studio_setup.png-wvc-sizes",
  alt: "Professional content creation studio setup for high-end brand production",
  aspect: "aspect-[4/5]",
  layout: "right-offset"
}, {
  number: "03",
  name: "Conversion Catalyst",
  location: "UTRECHT, NETHERLANDS",
  year: "2023",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/digital_marketing_analytics_report.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/digital_marketing_analytics_report.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/digital_marketing_analytics_report.webp-wvc-sizes",
  alt: "Digital marketing analytics report highlighting conversion rate optimization",
  aspect: "aspect-[16/9]",
  layout: "full"
}, {
  number: "04",
  name: "Community Pulse",
  location: "EINDHOVEN, NETHERLANDS",
  year: "2023",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/community_engagement_metrics.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/community_engagement_metrics.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723703/img/community_engagement_metrics.webp-wvc-sizes",
  alt: "Community engagement metrics dashboard showing active audience interaction",
  aspect: "aspect-[4/5]",
  layout: "center-right"
}];
function ProjectCard({
  project,
  index
}: {
  project: (typeof projects)[number];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15,
    rootMargin: "0px 0px -80px 0px"
  });
  return <div ref={ref} data-index={index} className={`group relative transition-all duration-700 ease-out ${isVisible ? "opacity-100 [clip-path:inset(0%_0_0_0)]" : "opacity-0 [clip-path:inset(100%_0_0_0)]"}`}>
      <div className={`relative overflow-hidden ${project.aspect} bg-secondary cursor-pointer rounded-lg shadow-md`}>
        <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />
        <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/10 transition-colors duration-500" />
      </div>
      <div className="mt-6 flex items-start justify-between gap-6">
        <div className="flex items-start gap-6">
          <span className="font-default text-[11px] tracking-[0.2em] text-muted-foreground pt-1">
            {project.number}
          </span>
          <div>
            <h3 className="font-default font-bold text-lg text-foreground uppercase">
              {project.name}
            </h3>
            <p className="mt-1 font-default text-[11px] tracking-[0.2em] uppercase text-primary">
              {project.location}
            </p>
          </div>
        </div>
        <span className="font-default text-[11px] tracking-[0.2em] text-muted-foreground pt-1">
          {project.year}
        </span>
      </div>
    </div>;
}
export default function CaseStudy() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return;
}